<template>
	<el-tabs type="border-card" style="height: 100%">
		<el-tab-pane v-for="tab in tabs" :key="tab.index" :label="tab.label" style="height: 100%">
			<fullnode-container v-if="tab.index == 0" :scrId="scrId" />
			<tree-container v-if="tab.index == 1" :scrId="scrId" />
			<filternode-container v-if="tab.index == 2" :scrId="scrId" />
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
import TreeContainer from './TreenodeContainer.vue';
import FullnodeContainer from './FullnodeContainer.vue';
import FilternodeContainer from './FilternodeContainer.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		TreeContainer,
		FullnodeContainer,
		FilternodeContainer
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		tabs() {
			return [
				{
					label: this.getMessage_('SWCC000753'),
					index: '0'
				},
				{
					label: this.getMessage_('SWCC000752'),
					index: '1'
				},
				{
					label: this.getMessage_('SWCC000751'),
					index: '2'
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods
	},
	created() {}
};
</script>

<style></style>
